module.exports = __webpack_public_path__ + "img/郑俊.c6454ff4.jpg";